import React, { useRef } from "react"
import { useTransition, useChain } from "react-spring"
import VisuallyHidden from "@reach/visually-hidden"

// Components
import { ButtonUnstyled } from "@components/button"
import Close from "@svgs/close"

// Data
import { menuItems as data } from "@data"

// Styles
import { MenuItem, Overlay, OverlayContent } from "./styles"

import "@reach/dialog/styles.css"

const Menu = ({ open, setOpen }) => {
  const showRef = useRef()
  const dialogTransitions = useTransition(open, null, {
    ref: showRef,
    from: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
    },
    leave: {
      opacity: 0,
    },
  })

  const transRef = useRef()
  const transitions = useTransition(open ? data : [], item => item.name, {
    ref: transRef,
    unique: true,
    trail: 400 / data.length,
    from: { opacity: 0, transform: "scale(0)" },
    enter: { opacity: 1, transform: "scale(1)" },
    leave: { opacity: 0, transform: "scale(0)" },
  })

  useChain(open ? [showRef, transRef] : [transRef, showRef], [
    0,
    open ? 0.1 : 0.1 * data.length,
  ])

  return dialogTransitions.map(
    ({ item, key, props }) =>
      item && (
        <Overlay key={key} style={props}>
          <OverlayContent>
            <ButtonUnstyled type="button" onClick={() => setOpen(false)}>
              <Close />
              <VisuallyHidden>Close Navigation</VisuallyHidden>
            </ButtonUnstyled>
            {transitions.map(({ item, key, props }) => (
              <MenuItem
                to={item.path}
                key={key}
                style={props}
                onClick={() => setOpen(false)}
              >
                {item.name}
              </MenuItem>
            ))}
          </OverlayContent>
        </Overlay>
      )
  )
}

export default Menu
